"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var OptGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(OptGroup, _Component);
  var _super = (0, _createSuper2["default"])(OptGroup);
  function OptGroup() {
    (0, _classCallCheck2["default"])(this, OptGroup);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2["default"])(OptGroup);
}(_react.Component);
exports["default"] = OptGroup;
(0, _defineProperty2["default"])(OptGroup, "isSelectOptGroup", true);